{
  "instances": {
    "loggers": {
      "label": "Loggers",
      "application": "Aplicación",

      "fetch_failed_some_instances": "Falla obteniendo loggers para {failed} de {count} instancias. Configurar loggers para estas probablemente falle.",
      "filter": {
        "class_only": "sólo clases",
        "configured": "configurado"
      },
      "instance": "Instancia",
      "new": "nuevo",
      "no_loggers_found": "No se encontraron loggers.",
      "unset": "Reiniciar",
      "setting_loglevel_failed": "Falla al cambiar {logger} a {loglevel}."
    }
  }
}
